/**
 * Fires a function after the window ready.
 *
 * @param {function} fn - function to call
 * @return {void}
 */
export const ready = (fn) => {
  if (document.readyState !== 'loading') {
    fn();
  }
  else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', fn);
  }
  else {
    document.attachEvent('onreadystatechange', () => {
      if (document.readyState !== 'loading') {
        fn();
      }
    });
  }
};

export default ready;
